
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auto-loan",
      function () {
        return require("private-next-pages/auto-loan.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/auto-loan"])
      });
    }
  